//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

interface LogoutButtonProps {
  text: string;
  style?: React.CSSProperties;
  className?: string;
}

function LogoutButton({ text, style, className }: Readonly<LogoutButtonProps>) {
  const [shouldLogout, setShouldLogout] = useState(false);

  /* 
  TODO We are re-signing in here to work around a Keycloak issues where the KC_RESTART cookie is lost
  Re-signing in will re-establish the KC_RESTART token ( or direct the user to login if the session is invalid )
  */
  if (shouldLogout) {
    return <Navigate to="/logout?reSignin=true" replace />;
  }

  return (
    <button
      id="logout-button"
      onClick={() => {
        setShouldLogout(true);
      }}
      style={style}
      className={className}
    >
      {text}
    </button>
  );
}

export default LogoutButton;
